import { render, staticRenderFns } from "./TifTurnoMapa.vue?vue&type=template&id=2f7d3c04"
import script from "./TifTurnoMapa.vue?vue&type=script&lang=js"
export * from "./TifTurnoMapa.vue?vue&type=script&lang=js"
import style0 from "./TifTurnoMapa.vue?vue&type=style&index=0&id=2f7d3c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports